document.addEventListener('DOMContentLoaded', function () {
  function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');

    return msie > 0 || trident > 0;
  }

  if (!isIE()) return;
  const hiddenInput = document.querySelector('#{{ product_form_id }} input[name="id"]');
  const noScriptInputWrapper = document.createElement('div');
  const variantSwitcher =
    document.querySelector('variant-radios[data-section="{{ section.id }}"]') ||
    document.querySelector('variant-selects[data-section="{{ section.id }}"]');
  noScriptInputWrapper.innerHTML = document.querySelector(
    '.product-form__noscript-wrapper-{{ section.id }}'
  ).textContent;
  variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;

  document.querySelector('#Variants-{{ section.id }}').addEventListener('change', function (event) {
    hiddenInput.value = event.currentTarget.value;
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var elem = document.querySelector('.product__media-list');
  var productImage = document.querySelectorAll('.product__media-item');
  var carouselCells = document.querySelectorAll('.product__media-list .product__media-item');
  var fancyElements = carouselCells.length;

  if (window.innerWidth < 769) {
    setTimeout(function () {
      var flkty = new Flickity(elem, {
        // options
        cellAlign: 'left',
        contain: true,
        arrowShape: {
          x0: 10,
          x1: 50,
          y1: 40,
          x2: 55,
          y2: 35,
          x3: 20,
        },
      });

      // Rest of the code remains the same
    }, 500);
  } else {
    elem.classList.add('grid');
    elem.classList.add('grid-peek');
    productImage.forEach(function (image) {
      image.classList.add('grid__item');
    });
  }

  // Move the code outside the if condition
  if (fancyElements >= 1) {
    carouselCells.forEach(function (cell, index) {
      cell.addEventListener('click', function () {
        openFancybox(index);
      });
    });

    function openFancybox(startIndex) {
      Fancybox.bind('[data-fancybox="gallery"]', {
        options: {
          contentClick: false,
          contentDblClick: 'toggleZoom',
        },
        on: {
          done: (fancybox, slide) => {
            if (fancybox.isCurrentSlide(slide)) {
              document.querySelectorAll('.f-thumbs__slide')[startIndex].click();
            }
          },
        },
      });
    }
  }
});
